module.exports = __webpack_public_path__ + "static/media/learning-22.ca56a706.png";